<template>
    <nuxt-layout name="main" :dark="true" :favorite="true">
        <!-- * 添加序列弹窗 -->
        <modal-add ref="modal" @change="methods.change" />
        <!-- * 提示弹窗 -->
        <modal-message ref="message" />
        <!-- * 模型介绍 -->
        <ui-modal ref="info" height="auto" spacing="32px 56px 40px">
            <div class="text-emphas text-[30px] leading-[46px] font-bold">{{ $t("ModelIntroduction") }}</div>
            <div class="mt-[16px]">
                <p>{{ $t("SequenceAlignmentIntroduction") }}</p>
            </div>
        </ui-modal>

        <!-- * 主体 -->
        <div :class="css.container">
            <h1 :class="css.title" class="color-1 font-bold font-variable">{{ $t("SequenceAlignment") }}</h1>
            <div :class="css.body">
                <div class="flex justify-between items-center mb-[16px]">
                    <h2 class="text-emphas text-[16px] leading-[32px] font-bold">{{ $t("PlesaseAddSequencesAligned") }}:</h2>
                    <div class="flex items-center">
                        <h2 class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="info?.openModal()">
                            {{ $t("ModelIntroduction") }}
                        </h2>
                        <div class="w-[1px] h-[12px] mx-[16px] bg-emphas"></div>
                        <h2 class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="methods.next">
                            {{ $t("VideoTutorial") }}
                        </h2>
                        <div class="w-[1px] h-[12px] mx-[16px] bg-emphas"></div>
                        <h2 class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="methods.image">
                            {{ $t("TextTutorial") }}
                        </h2>
                    </div>
                </div>
                <div :class="css.item" class="bg-color7" v-for="(value, index) in data">
                    <div :class="css.num" class="color-1 font-bold">{{ (index + 1).toString().padStart(2, "0") }}</div>
                    <div :class="css.box" @click="modal?.open(value, index)">
                        <div :class="css.name" class="ellipsis" v-html="value.name"></div>
                        <div class="ellipsis" v-html="value.sequence.slice(0, 1000)"></div>
                    </div>
                    <div :class="css.close" @click="methods.remove(index)"><ui-icon name="close2" /></div>
                </div>
                <ui-button :class="css.add" @click="methods.open"> <ui-icon name="plus" />{{ $t("AddASequence") }} </ui-button>
            </div>

            <div :class="css.footer">
                <ui-button :class="css.submit" :width="144" @click="methods.submit">{{ $t("Submit") }}</ui-button>
            </div>
        </div>
    </nuxt-layout>
</template>

<script lang="tsx" setup>
//* 组件库
import { UiIcon, UiModal, UiButton } from "various-ui";
//* 私有组件
import ModalAdd from "./components/add/index.vue";
import ModalMessage from "./components/message/index.vue";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 组合函数
const { refs, nodes, methods } = useComposable();
const { info, modal, message } = nodes;
const { data } = refs;
</script>
